<template>
  <div class="introduction">
    <div class="item">
      <h3>个人信息</h3>
      <ul class="card">
        <li>F F / 92</li>
        <li>前端开发 / {{time}}工作经验{{ date ? '（' + date.time + '）' : ''}}</li>
        <li>Email：wef_1020@163.com</li>
        <li>博客网：www.flikef.com</li>
      </ul>
    </div>
    <div class="item">
      <h3>技能特长</h3>
      <ul class="card">
        <li>精通HTML5/CSS3/JavaScript等前端相关技术；</li>
        <li>掌握JavaScript语言核心技术DOM、BOM、Ajax、JSON等；</li>
        <li>前端技术栈擅长Vue、 微信小程序、 uni-app等，擅长组件开发及构建优化；</li>
        <li>后端熟悉使用Nodejs开发，数据库熟悉MySQL，NeDB；</li>
        <li>熟悉使用electron开发简单的桌面应用；</li>
        <li>熟悉MQTT的使用。</li>
      </ul>
    </div>
    <div class="item">
      <h3>项目经验</h3>
      <ul class="card1">
        <h5>第二届军民协同创新创业大赛报名系统（2020-06 ~ 2020-07）</h5>
        <h4>项目负责人/前端开发</h4>
        <li>- 参与项目需求研讨、项目架构、技术选型；</li>
        <li>- 使用 Vue + Axios + Element ui 等技术栈开发。</li>
      </ul>
      <ul class="card1">
        <h5>第二届军民协同创新创业大赛后台管理系统（2020-07 ~ 2020-08）</h5>
        <h4>项目负责人/前端开发</h4>
        <li>- 参与项目需求研讨、项目架构、技术选型；</li>
        <li>- 使用 Vue + Axios + Echarts + Element ui 等技术栈开发。</li>
      </ul>
      <ul class="card1">
        <h5>LED手持弹幕工具（2020-05）</h5>
        <h4>项目负责人/小程序开发+APP开发</h4>
        <li>- 项目需求研讨、项目架构、技术选型；</li>
        <li>- 小程序前端使用微信小程序技术栈开发；</li>
        <li>- APP前端使用uni-app技术栈开发。</li>
        <h4>项目地址：</h4>
        <li>- 微信小程序与QQ小程序；</li>
        <li>- APP暂上架小米应用商店；</li>
        <li>- 或电脑访问屏幕分辨率大于1800左侧扫码进入。</li>
      </ul>
      <ul class="card1">
        <h5>同学录回忆（2019-12）</h5>
        <h4>项目负责人/小程序开发+后端开发</h4>
        <li>- 项目需求研讨、项目架构、技术选型；</li>
        <li>- 前端使用微信小程序技术栈开发；</li>
        <li>- 后端使用Nodejs + Express等框架，数据存储使用MySQL。</li>
        <h4>项目地址：</h4>
        <li>- 微信小程序与QQ小程序；</li>
        <li style="color: red">- 注：微信小程序须从同名的公众号进入；</li>
        <li>- 或电脑访问屏幕分辨率大于1800左侧扫码进入。</li>
      </ul>
    </div>
    <div class="item">
      <h3>自我评价</h3>
      <ul class="card">
        <li>细节把握细致，性格外向开朗，敢于承担责任；</li>
        <li>全身心投入并以真诚负责的态度对待工作，寻求自我价值的不断提升。</li>
      </ul>
    </div>
  </div>
</template>

<script>
  function getDistanceDay(time) {
    let stime = new Date().getTime();
    let usedTime = stime - time; //两个时间戳相差的毫秒数
  
    let one_minute = 60 * 1000;
    let one_hour = 60 * 60 * 1000;
    let one_day = 24 * 60 * 60 * 1000;
    let timeTxt = '';
    if (usedTime >= one_day) {
      //相差几天
      let disparityDay = parseInt(usedTime / one_day);
  
      timeTxt = disparityDay + '天+';
      if (disparityDay > getMonthDay()) timeTxt = getDisparityMonth(disparityDay) + '月+';
  
      if (disparityDay > getYearDay()) timeTxt = parseInt(disparityDay / getYearDay()) + '年+';
  
    } else {
      if (usedTime >= one_hour) {
        timeTxt = parseInt(usedTime / one_hour);
      } else if (usedTime >= one_minute) {
        timeTxt = parseInt(usedTime / one_minute);
      } else {
        timeTxt = '刚刚';
      }
    }
    return timeTxt;
  }
  
  // 获取相差几个月 传天数
  function getDisparityMonth(disparityDay) {
    let disparityMonth = 0;
    let countFc = () => {
      if (disparityDay > getMonthDay(disparityMonth)) {
        disparityDay -= getMonthDay(disparityMonth)
        disparityMonth += 1;
        countFc(disparityMonth)
      } else {
        return disparityMonth;
      }
    }
    countFc(disparityMonth)
    return disparityMonth;
  }
  
  // 获取当前月
  function getNowMonth() {
    return new Date().getMonth() + 1;
  }
  
  // 获取当前月有多少天 可以计算前面几个月有多少天 upNum 是前面几个月
  function getMonthDay(upNum) {
    let day = 0;
    let month = getNowMonth();
    if (upNum) {
      let date = new Date();
      date.setMonth(date.getMonth() - upNum);
      month = date.getMonth() + 1;
    }
    if (month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) {
      day = 31
    } else if (month == 2) {
      if (getYearDay() == 366) day = 29
      if (getYearDay() == 365) day = 28
    } else {
      day = 30
    }
    return day;
  }
  
  // 获取当前年有多少天
  function getYearDay() {
    let day = 365
    let year = new Date().getFullYear();
    if (year % 4 == 0) day = 366;
    return day
  }

  var timing
  export default {
    name: 'introduction', //简介
    metaInfo () {
      return {
        title:'F F 的 Blog'
      }
    },

    data () {
      return {
        time: '',
        startTime: '2017/03/27 18:18:18', //2017-03-27 18:18:18
        date: ''
      }
    },

    mounted () {
      let time = (new Date().getTime()) -((new Date().getTime()) - new Date(this.startTime).getTime())
      let timeText = getDistanceDay(time)
      this.time = timeText
      this.date = this.getDate()
      timing = setInterval(() => {
        this.date = this.getDate()
      }, 1000)
    },

    methods: {
      getDate () {
        let t = new Date(this.startTime).getTime()
        let now = new Date().getTime()
        let elapsed = parseInt(now / 1000 - t / 1000)
        let d = parseInt(elapsed / (3600 * 24))//计算出相差天数
        let h = parseInt((elapsed / 3600) % 24)//扣除相差天数，计算出相差小时数
        h = h < 10 ? '0' + h : h
        let m = parseInt((elapsed / 60) % 60)//扣除相差天数，小时数，计算出相差分钟数
        m = m < 10 ? '0' + m : m
        let s = parseInt(elapsed % 60)//扣除相差天数、小时数、分钟数相差数，计算出相差秒速
        s = s < 10 ? '0' + s : s
        let time = d + '天' + h + "小时" + m + "分" + s + "秒"

        let hour = parseInt(elapsed / 3600).toLocaleString() + ' 小时'
        let minute = parseInt(elapsed / 60).toLocaleString() + ' 分钟'
        let second = elapsed.toLocaleString() + ' 秒'
        let date = {
          time,
          hour,
          minute,
          second
        }
        return date
      },

      //时间转换
      s_to_hs (s) {
        //计算分钟
        //算法：将秒数除以60，然后下舍入，既得到分钟数
        var h
        h = Math.floor(s / 60)
        //计算秒
        //算法：取得秒%60的余数，既得到秒数
        s = s % 60
        //将变量转换为字符串
        h += ''
        s += ''
        //如果只有一位数，前面增加一个0
        h = (h.length == 1) ? '0' + h : h
        s = (s.length == 1) ? '0' + s : s
        return h + ':' + s
      },
    },

    destroyed() {
      clearInterval(timing)
    },
  }
</script>

<style>
  .introduction {
    background-color: #ffffff;
    margin-top: 30px;
    margin-bottom: 30px;
    box-shadow: 0px 0px 5px 0px #cccccc;
    box-sizing: border-box;
    padding: 30px 0;
  }

  .introduction .item h3 {
    color: #000;
    padding-left: 20px;
    border-left: 5px solid #077ddd;
    box-sizing: border-box;
  }

  .introduction .card,
  .introduction .card1 {
    background-color: #eaecf7;
    margin: 25px;
    box-sizing: border-box;
    padding: 10px 20px;
    color: sienna;
    line-height: 35px;
    border-radius: 10px;
  }

  .introduction .card li::before {
    content: "";
    margin-right: 10px;
    text-align: center;
    font-weight: 700;
    color: sienna;
    display: inline-block;
    min-width: 8px;
    min-height: 8px;
    background-color: sienna;
    border-radius: 50%;
  }

</style>



// WEBPACK FOOTER //
// src/views/introduction.vue